import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';

export const FILTER_QUERY_KEYS = {
    FACILITIES: 'facilities',
    CROSS_DOCKS: 'crossDocks',
};

export const CROSS_DOCK_PURCHASE_ORDER_STATUS_OPTIONS = [
    { value: 'PLACED', label: 'Placed' },
    { value: 'RECEIVED', label: 'Received' },
    { value: 'IN PROGRESS', label: 'In Progress' },
    { value: 'CANCELLED', label: 'Cancelled' },
];

export const idFilterConfig = {
    key: 'id',
    label: 'Cross Dock PO ID',
    type: FilterType.NUMBER,
    deletable: true,
    placeholder: 'Enter cross dock PO ID...',
};

export const purchaseOrderIdFilterConfig = {
    key: 'purchaseOrderId',
    label: 'Purchase Order ID',
    type: FilterType.NUMBER,
    deletable: true,
    placeholder: 'Enter purchase order ID...',
};

export const packagingPurchaseOrderIdFilterConfig = {
    key: 'packagingPurchaseOrderId',
    label: 'Packaging Purchase Order ID',
    type: FilterType.NUMBER,
    deletable: true,
    placeholder: 'Enter packaging purchase order ID...',
};

export const statusFilterConfig = {
    key: 'statuses',
    label: 'Status',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: CROSS_DOCK_PURCHASE_ORDER_STATUS_OPTIONS,
    deletable: true,
    menuProps: {
        placeholder: 'Select statuses...',
        mergeWithStaticOptions: false,
    },
};

export const facilityFilterConfig = {
    key: 'facilityIds',
    label: 'Facility',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: FILTER_QUERY_KEYS.FACILITIES,
    },
    menuProps: {
        placeholder: 'Search facilities...',
        mergeWithStaticOptions: false,
    },
};

export const crossDockFilterConfig = {
    key: 'crossDockIds',
    label: 'Destination Cross Dock',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: FILTER_QUERY_KEYS.CROSS_DOCKS,
    },
    menuProps: {
        placeholder: 'Search cross docks...',
        mergeWithStaticOptions: false,
    },
};

export const scheduledDeliveryDateRangeFilterConfig = {
    key: 'scheduledDeliveryDateRange',
    label: 'Scheduled Delivery Date',
    type: FilterType.DATE_RANGE,
    deletable: true,
};

export const CrossDockPurchaseOrderFilterConfigArray = [
    idFilterConfig,
    purchaseOrderIdFilterConfig,
    packagingPurchaseOrderIdFilterConfig,
    statusFilterConfig,
    facilityFilterConfig,
    crossDockFilterConfig,
    scheduledDeliveryDateRangeFilterConfig,
];

export const CrossDockPurchaseOrderTransformConfig = {
    dateRangeKeys: {
        scheduledDeliveryDateRange: {
            start: 'scheduledDeliveryDateStart',
            end: 'scheduledDeliveryDateEnd',
        },
    },
    numericArrayKeys: ['facilityIds', 'crossDockIds'],
    stringArrayKeys: ['statuses'],
};
